























































import Vue, { PropType } from 'vue'

import firebase from 'firebase/app'
import 'firebase/database'
import { TranslateResult } from 'vue-i18n'

import HeaderGame from '@/components/widgets/bar/HeaderGame.vue'
import MapsWithFriends from '@/components/MapsWithFriends.vue'
import DialogMessage from '@/components/widgets/dialog/DialogMessage.vue'

export type DataType = {
  panorama: google.maps.StreetViewPanorama | null,
  randomLatLng: google.maps.LatLng | null,
  randomLat: number | null,
  randomLng: number | null,
  score: number,
  scoreHeader: number,
  round: number,
  timeLimitation: number,
  remainingTime: number,
  hasTimerStarted: boolean,
  hasLocationSelected: boolean,
  overlay: boolean,
  room: firebase.database.Reference | null,
  placesService: google.maps.places.PlacesService | null,
  isReady: boolean,
  dialogMessage: boolean,
  dialogTitle: TranslateResult,
  dialogText: TranslateResult,
}

export default Vue.extend({
  name: 'StreetViewWithFriends',

  props: {
    roomName: String,
    playerNumber: Number,
  },

  components: {
    HeaderGame,
    MapsWithFriends,
    DialogMessage,
  },

  data(): DataType {
    return {
      panorama: null,
      randomLatLng: null,
      randomLat: null,
      randomLng: null,
      score: 0,
      scoreHeader: 0,
      round: 1,
      timeLimitation: 0,
      remainingTime: 0,
      hasTimerStarted: false,
      hasLocationSelected: false,
      overlay: false,
      room: null,
      placesService: null,
      isReady: false,
      dialogMessage: true,
      dialogTitle: this.$t('StreetViewWithFriends.waitForOtherPlayers'),
      dialogText: '',
    }
  },

  methods: {
    loadStreetView(): void {
      this.getNextGuessLocation((latLng: google.maps.LatLng) => {
        let service = new google.maps.StreetViewService()
        service.getPanorama({
          location: latLng,
          preference: google.maps.StreetViewPreference.NEAREST,
          radius: 100000,
          source: google.maps.StreetViewSource.OUTDOOR,
        }, this.checkStreetView)
      })
    },

    loadDecidedStreetView(): void {
      let service = new google.maps.StreetViewService()
      service.getPanorama({
        location: {
          lat: this.randomLat!,
          lng: this.randomLng!,
        },
        preference: google.maps.StreetViewPreference.NEAREST,
        radius: 100000,
        source: google.maps.StreetViewSource.OUTDOOR,
      }, this.checkStreetView)    
    },
    getNextGuessLocation(locationCallback: (latLng: google.maps.LatLng) => void) {
      this.room!.once('value', (snapshot) => {
        let topic = snapshot.child('roomTopic').val()
        let rand = this.getRandomLatLng();
        if(topic === 'random') {
          locationCallback(rand)
          return
        }
        let locallyStoredString = localStorage.getItem(topic);
        if(locallyStoredString) {
          this.getRandomGuessLocationFromList(JSON.parse(locallyStoredString), locationCallback)
          return
        }
        // query Maps
        if(!this.placesService) {
          this.placesService = new google.maps.places.PlacesService(document.getElementById('street-view') as HTMLDivElement)
        }
        let request = {
          query: topic,
        }
        let results: google.maps.LatLng[] = [];
        console.log('querry google maps with', request);
        this.placesService.textSearch(request, (result: google.maps.places.PlaceResult[],
                                                status: google.maps.places.PlacesServiceStatus,
                                                pagination: google.maps.places.PlaceSearchPagination) => {
          if(status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT && results.length > 5) {
            this.getRandomGuessLocationFromList(results, locationCallback)
            return
          } else if(status !== google.maps.places.PlacesServiceStatus.OK) {
            locationCallback(rand)
            return
          }
          results = results.concat(result.map(r => r.geometry!.location).filter(r => r))
          if(pagination && pagination.hasNextPage && results.length < 100) {
            setTimeout(() => {
              pagination.nextPage()
            }, 1000)
          } else {
            // no more pages to load, so select a random one and store it in local storage
            localStorage.setItem(topic, JSON.stringify(results))
            this.getRandomGuessLocationFromList(results, locationCallback)
          }
        })
      })
    },
    getRandomGuessLocationFromList(list: google.maps.LatLng[], locationCallback: (latLng: google.maps.LatLng) => void) {
      let index = Math.round(Math.random() * list.length)
      locationCallback(list[index])
    },
    getRandomLatLng() {
      // Generate a random latitude and longitude
      let lat = (Math.random() * 170) - 85
      let lng = (Math.random() * 360) - 180
      return new google.maps.LatLng(lat, lng)
    },

    checkStreetView(data: google.maps.StreetViewPanoramaData | null, status: google.maps.StreetViewStatus): void {
      if (status === google.maps.StreetViewStatus.OK) {
        this.panorama = new google.maps.StreetViewPanorama(document.getElementById('street-view') as HTMLElement)
        this.panorama.setOptions({
          zoomControl: false,
          addressControl: false,
          fullscreenControl: false,
          motionTracking: false,
          motionTrackingControl: false,
          showRoadLabels: false,
        })
        this.panorama.setPano(data!.location!.pano!)
        this.panorama.setPov({
          heading: 270,
          pitch: 0,
        })

        // Save the location's latitude and longitude
        this.randomLatLng = data!.location!.latLng! as google.maps.LatLng

        this.randomLat = this.randomLatLng!.lat()
        this.randomLng = this.randomLatLng!.lng()

                // Put the streetview's location into firebase
        this.room!.child('streetView/round' + this.round).set({
          latitude: this.randomLat,
          longitude:this.randomLng
        })

      } else {
        this.loadStreetView()
      }
    },

    startTimer(): void {
      if (!this.hasLocationSelected) {
        if (this.remainingTime > 0) {
          setTimeout(() => {
            this.remainingTime -= 1
            this.startTimer()
          }, 1000)
        } else {
          // Set a random location if the player didn't select a location in time
          let mapRef = this.$refs.map as any
          mapRef!.selectGivenLocation(mapRef.selectedLatLng ? mapRef.selectedLatLng : this.getRandomLatLng())
        }
      }
    },

    updateScore(distance: number): void {
      this.hasLocationSelected = true
      this.score += distance
      this.room!.child('finalScore/player' + this.playerNumber).set(this.score)

      this.dialogTitle = this.$t('StreetViewWithFriends.waitForOtherPlayers') as TranslateResult
      this.dialogMessage = true
    },

    showResult(): void {
      this.scoreHeader = this.score
      this.dialogMessage = false
      this.overlay = true
    },

    goToNextRound(): void {
      // Reset
      this.randomLatLng = null
      this.overlay = false
      this.isReady = false
      this.dialogMessage = true
      this.hasTimerStarted = false
      this.hasLocationSelected = false
      this.round += 1

      if (this.playerNumber === 1) {
        this.loadStreetView()
      } else {
        this.room!.child('trigger/player' + this.playerNumber).set(this.round)
        let mapRef = this.$refs.map as any
        mapRef.startNextRound()
      }
    },

    exitGame(): void {
      this.dialogTitle = this.$t('StreetViewWithFriends.redirectToHomePage') as TranslateResult
      this.dialogText = this.$t('StreetViewWithFriends.exitGame') as TranslateResult
      this.dialogMessage = true

      if (this.room !== null) {
        this.room.off()
        this.room.remove()
      }      
      setTimeout(() => {
        this.$router.push({ name: 'home' })
      }, 5000)
    },

    finishGame(): void {
      this.dialogTitle = this.$t('StreetViewWithFriends.waitForOtherPlayersToFinish') as TranslateResult
      this.dialogText = ''
      this.dialogMessage = true
    },

    resetLocation(): void {
      this.panorama!.setPosition(this.randomLatLng!)
    },

    zoomIn(): void {
      let currentLevel = this.panorama!.getZoom()
      currentLevel++
      this.panorama!.setZoom(currentLevel)
    },

    zoomOut(): void {
      let currentLevel = this.panorama!.getZoom()
      currentLevel--
      this.panorama!.setZoom(currentLevel)
    },
  },

  mounted(): void {
    this.room = firebase.database().ref(this.roomName)
    if (this.playerNumber === 1) {
      this.loadStreetView()
    }

    // Set a default room name if it's null to check if the user refresh the page
    if (this.roomName === null || this.roomName === undefined) {
      this.exitGame()
    } else {

      this.room!.child('active').set(true)
      this.room!.on('value', (snapshot) => {
        // Check if the room is already removed
        if (snapshot.hasChild('active')) {

          // Put the player into the current round node if the player is not put yet
          if (!snapshot.child('round' + this.round).hasChild('player' + this.playerNumber)) {

            this.room!.child('round' + this.round).child('player' + this.playerNumber).set(0)

            // Other players load the streetview the first player loaded earlier
            if (this.playerNumber !== 1) {
              this.randomLat = snapshot.child('streetView/round' + this.round + '/latitude').val()
              this.randomLng = snapshot.child('streetView/round' + this.round + '/longitude').val()

              this.loadDecidedStreetView()
            }
          }

          // Enable guess button when all players are put into the current round's node
          if (snapshot.child('round' + this.round).numChildren() === snapshot.child('size').val()) {
            // Close the dialog when all players get ready
            if (this.isReady === false) {
              this.dialogMessage = false
            }

            this.isReady = true
            let mapRef = this.$refs.map as any
            mapRef.startNextRound()
            this.timeLimitation = snapshot.child('timeLimitation').val() * 60

            if (this.timeLimitation !== 0) {
              if (!this.hasTimerStarted) {
                this.remainingTime = this.timeLimitation
                this.startTimer()
                this.hasTimerStarted = true
              }
            }
          }

          // Delete the room when all players finished the game
          if (snapshot.child('isGameDone').numChildren() === snapshot.child('size').val()) {
            this.room!.child('active').remove()
          }
        } else {
          // Force the players to exit the game when 'Active' node has been removed
          this.exitGame()
        }
      })

      // Remove the room when the player pressed the back button on browser
      window.addEventListener('popstate', (event) => {
        this.room!.child('active').remove()
        this.room!.off()
      })

      // Remove the room when the player refreshes the window
      window.addEventListener('beforeunload', (event) => {
        this.room!.child('active').remove()
        this.room!.off()
      })
    }
  }
})
